module.exports = __webpack_public_path__ + "img/video.9ff01d85.svg";